/**
 * iurop-number-roll.js — Transición de número estilo Apple (fade + slide)
 *
 * Módulo autocontenido (sin dependencias/CDN). Al cambiar un valor, el número
 * ANTIGUO sale hacia arriba desvaneciéndose y el NUEVO entra desde abajo. Usa
 * solo `transform` y `opacity` (compositor) → CERO reflow / cero layout shift.
 *
 * Se evitó el odómetro por dígitos a propósito: la serif de marca (Georgia) usa
 * cifras de estilo antiguo (con descendentes) y ancho variable, lo que hacía que
 * los dígitos se descuadraran y "repositionaran" unos píxeles.
 *
 * Uso: window.IuropRoll.animate(el, fromText, toText)
 *   El elemento debe ser transformable (flex item, o inline-block). Guarda el
 *   valor limpio en `data-roll-text` en el Liquid para leer from/to sin ruido.
 */
(function () {
  'use strict';

  var OUT_MS = 150;
  var IN_MS = 240;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canAnimate = typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';

  function animate(el, fromStr, toStr) {
    toStr = String(toStr);
    if (fromStr != null && String(fromStr) === toStr) {
      return;
    }
    if (reduce || !canAnimate) {
      el.textContent = toStr;
      return;
    }

    // Cancela una animación en curso para no encadenar estados intermedios.
    if (el._rollAnim) {
      try { el._rollAnim.cancel(); } catch (e) {}
    }

    var out = el.animate(
      [
        { transform: 'translateY(0)', opacity: 1 },
        { transform: 'translateY(-45%)', opacity: 0 }
      ],
      { duration: OUT_MS, easing: 'cubic-bezier(0.4, 0, 1, 1)' }
    );
    el._rollAnim = out;

    out.onfinish = function () {
      // Fija invisible durante el swap de texto (evita el flash de 1 frame).
      el.style.opacity = '0';
      el.textContent = toStr;
      var inn = el.animate(
        [
          { transform: 'translateY(45%)', opacity: 0 },
          { transform: 'translateY(0)', opacity: 1 }
        ],
        { duration: IN_MS, easing: 'cubic-bezier(0, 0, 0.2, 1)' }
      );
      el._rollAnim = inn;
      inn.onfinish = function () {
        el.style.opacity = '';
        el._rollAnim = null;
      };
    };
  }

  window.IuropRoll = { animate: animate };
})();
